























import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import Meter from './widgets/Meter.vue';

@Component({
  components: {
    Meter,
  },
})
export default class Language extends Vue {
    @Inject() private resume!: Resume;
}
